//import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';

import './css/mhss.scss';
import axios from "axios";
import 'react-dates/initialize';
import { CookiesProvider } from 'react-cookie';
import { loadTheme } from '@fluentui/react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from "history";
import configureStore from './ConfigureStore';
import Startup, { ErrorBoundary } from './Startup';
import { ShiftProvider } from './Context/ShiftsContext'
import { initializeIcons } from '@fluentui/font-icons-mdl2';
initializeIcons();


loadTheme({
    defaultFontStyle: { fontFamily: 'Wfvisualsans, Helvetica Neue, Helvetica, Arial, sans-serif', fontWeight: 'regular', letterSpacing: '-0.3px' },
    fonts: {
        small: {
            fontSize: '11px'
        },
        medium: {
            fontSize: '14px'
        },
        large: {
            fontSize: '20px',
            fontWeight: 'semibold'
        },
        xLarge: {
            fontSize: '22px',
            fontWeight: 'semibold'
        }
    },
    palette: {
        themePrimary: 'var(--themePrimary2)',
        themeLighterAlt: 'var(--fui-themeLighterAlt)',
        themeLighter: 'var(--fui-themeLighter)',
        themeLight: 'var(--fui-themeLight)',
        themeTertiary: 'var(--fui-themeTertiary)',
        themeSecondary: 'var(--fui-themeSecondary)',
        themeDarkAlt: 'var(--fui-themeDarkAlt)',
        themeDark: 'var(--fui-themeDark)',
        themeDarker: 'var(--fui-themeDarker)',
        neutralLighterAlt: 'var(--fui-neutralLighterAlt)',
        neutralLighter: 'var(--fui-neutralLighter)',
        neutralLight: 'var(--fui-neutralLight)',
        neutralQuaternaryAlt: 'var(--fui-neutralQuaternaryAlt)',
        neutralQuaternary: 'var(--fui-neutralQuaternary)',
        neutralTertiaryAlt: 'var(--fui-neutralTertiaryAlt)',
        neutralTertiary: 'var(--fui-neutralTertiary)',
        neutralSecondary: 'var(--fui-neutralSecondary)',
        neutralPrimaryAlt: 'var(--fui-neutralPrimaryAlt)',
        neutralPrimary: 'var(--fui-neutralPrimary)',
        neutralDark: 'var(--fui-neutralDark)',
        black: 'var(--fui-black)',
        white: 'var(--fui-white)',
    }
});



const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = {};

const store = configureStore(history, initialState);
window.store = store;


const ErrorFallback = () => (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 24 }}>
        <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/teamsly-logo-35.png" alt="Teamsly" style={{ height: 32, marginBottom: 24 }} />
        <h2 style={{ marginBottom: 8 }}>Something went wrong</h2>
        <p style={{ marginBottom: 24, color: '#666' }}>An unexpected error occurred. Please refresh the page to continue.</p>
        <button onClick={() => window.location.reload()} style={{ padding: '8px 20px', borderRadius: 4, border: 'none', background: '#1d88da', color: '#fff', cursor: 'pointer' }}>Refresh page</button>
    </div>
);


ReactDOM.render(
    <CookiesProvider>
        <Provider store={store}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <ShiftProvider>
                    <Startup history={history}>

                        </Startup>
                </ShiftProvider>
            </ErrorBoundary>
        </Provider>
    </CookiesProvider>,
  rootElement);











